const FooterUsefulLinksNames = [
    { name: "Home" },
    { name: "Movies" },
    { name: "My List" },
    { name: "terms of Service" },
    { name: "privacy Policy" },
];
export default FooterUsefulLinksNames